
import React, { useState, useRef, useContext, useEffect } from 'react';
import { Transition } from 'react-transition-group';
import { iAeonOpenBrowser } from '../../library/iaeon_sdk.js';

import styles from '../../styles/Faq.module.scss'

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

const duration = 300;

// アコーディオンの項目
const accordionItems = [
	{
		question: 'お客さま感謝デーや、キャンペーンは適用されますか？',
		answer: <p>精算機でのお支払い時に適用されます。※アプリの画面上は適用前の金額となります。</p>
	},
	{
		question: '「レジゴー」のお会計方法について教えてください',
		answer: <p>精算機でのお支払い時に適用されます。※アプリの画面上は適用前の金額となります。</p>
	},
	{
		question: 'バーコードの無い商品はどうすればよいですか？',
		answer: <p>精算機でのお支払い時に適用されます。※アプリの画面上は適用前の金額となります。</p>
	},
	{
		question: '「レジゴー」でのお買い物に何か制限がありますか？',
		answer: <p>精算機でのお支払い時に適用されます。※アプリの画面上は適用前の金額となります。精算機でのお支払い時に適用されます。※アプリの画面上は適用前の金額となります。精算機でのお支払い時に適用されます。※アプリの画面上は適用前の金額となります。</p>
	},
	// 他の質問と回答をここに追加
];

export function Faq(props) {

// const [se08_se] = useSound(se_08);

useEffect(() => { // コンポーネントがマウントされた時に実行
	document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.remove('is_behind');
}, []); // 空の依存配列を渡すことで、コンポーネントのマウントとアンマウント時にのみ実行


// let title = "よくある質問"

// const { os, browser, device } = useContext(DeviceContext);
// 各アコーディオンの開閉状態を管理する状態
const [openStatus, setOpenStatus] = useState(accordionItems.map(() => false));

// refsを各アコーディオンに対して作成
const nodeRefs = useRef(accordionItems.map(() => React.createRef()));

// 高さのスタイルを管理する状態を各アコーディオンに対して作成
const [heightStyles, setHeightStyles] = useState(accordionItems.map(() => ({ height: 0 })));

// 各アコーディオンのコールバック関数を生成
const generateCallbacks = (index) => ({
	onEntering: () => {
		// 実際の高さを取得して設定
		setHeightStyles(prevStyles =>
			prevStyles.map((style, i) =>
				i === index ? { height: nodeRefs.current[i].current.scrollHeight } : style
			)
		);
	},
	onEntered: () => {
		// Transitionが終わったら、heightを'auto'に設定
		setHeightStyles(prevStyles =>
			prevStyles.map((style, i) =>
				i === index ? { height: 'auto' } : style
			)
		);
	},
	onExiting: () => {
		// 閉じるときは高さを明示的に設定し、0に戻す
		setHeightStyles(prevStyles =>
			prevStyles.map((style, i) =>
				i === index ? { height: nodeRefs.current[i].current.scrollHeight } : style
			)
		);
	},
	onExited: () => {
		// Transitionが終わったら、heightを0に設定
		setHeightStyles(prevStyles =>
			prevStyles.map((style, i) =>
			i === index ? { height: 0 } : style
			)
		);
	}
});

// アコーディオンのトグル関数
const toggleAccordion = (index) => {
	setOpenStatus(prevStatus =>
		prevStatus.map((status, i) =>
			i === index ? !status : status
		)
	);
	// se08_se();
	props.setSoundState("se08_se");
};

//25.外部ブラウザOpenAPI
function callAPI_25(surl){
    let successCall_25 = function(success){
		// alert("【iAeonOpenBrowser】success");
        var aaa = success;
		console.log('【iAeonOpenBrowser】success：' + aaa);

    }
    let errorCall_25 = function(error){
		// alert("【iAeonOpenBrowser】error: " + error);
		var bbb = error;
		console.log('【iAeonOpenBrowser】error: ' + error.error_code + " : " + error.message);
		props.setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		props.setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonOpenBrowser】call');
    iAeonOpenBrowser({"url":surl}).then(successCall_25).catch(errorCall_25);
}

return (
	<>
		<div className={styles.faqBlock}>
		<div id="faqBox" className={styles.faqBox}>
		{accordionItems.map((item, index) => (
		<React.Fragment key={index}>
			<button className={`${styles.faqBox_accordionBtn} ${openStatus[index] ? styles.is_open : ''}`} onClick={() => toggleAccordion(index)}>
				<span>{item.question}</span>
				<span className={`${styles.faqBox_accordionBtn_icn} ${styles.faqBox_accordionBtn_icn01}`}>
					<img src="/images/icn_accordion01.svg" alt="" width="16" height="16" />
				</span>
				<span className={`${styles.faqBox_accordionBtn_icn} ${styles.faqBox_accordionBtn_icn02}`}>
					<img src="/images/icn_accordion02.svg" alt="" width="16" height="16" />
				</span>
			</button>
			<Transition
			in={openStatus[index]}
			timeout={duration}
			{...generateCallbacks(index)}
			nodeRef={nodeRefs.current[index]}
			>
			{state => (
				<div
				ref={nodeRefs.current[index]}
				className={styles.faqBox_wrap}
				style={{
					transition: `opacity ${duration}ms ease-out, height ${duration}ms ease-out`,
					opacity: state === 'entered' ? 1 : 1,
					overflow: 'hidden',
					...heightStyles[index]
				}}
				>
				<div className={styles.faqBox_wrap_in}>
					{item.answer}
					{/* <p className={styles.faqBox_txt}>{item.answer}</p> */}
				</div>
				</div>
			)}
			</Transition>
		</React.Fragment>
		))}
		</div>

		{
			(() => {
				if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
				return(
					<button className={`${styles.globalNav_closeBtn} ${styles.faq_contactBtn} ${styles.custom_btn}`} onClick={()=>{callAPI_25('https://chat3-28b.chatdealer.jp/chat/url/12R8lds?vgAtxt=mi7DJChat3-28b');props.setSoundState("se08_se");}}><span>チャットでのお問い合わせ</span></button>
				)
				} else { //iAEON無効
				return (
					<a href="https://chat3-28b.chatdealer.jp/chat/url/12R8lds?vgAtxt=mi7DJChat3-28b" target='_blank' className={`${styles.globalNav_closeBtn} ${styles.faq_contactBtn} ${styles.custom_btn}`} onClick={()=>{props.setSoundState("se08_se");}}><span>チャットでのお問い合わせ</span></a>
				)
				}
			})()
		}
		</div>
	</>
)
}
